import type { AssetsBatchEditContentProps } from "./assets-batch-edit-content.type";

import { AssetsBatchEditAssetType } from "@/modules/assets/assets-batch-edit-asset-type";
import { AssetsBatchEditConditionRating } from "@/modules/assets/assets-batch-edit-condition-rating";
import { AssetsBatchEditLocation } from "@/modules/assets/assets-batch-edit-location";
import { AssetsBatchEditReplacementCost } from "@/modules/assets/assets-batch-edit-replacement-cost";
import BatchTransition from "@/modules/batch-transition";
import SidePanelFormFooter from "@/modules/side-panel-form-footer";

export const AssetsBatchEditContent = ({
  assets,
  property,
}: AssetsBatchEditContentProps) => {
  if (property === "state") {
    return <BatchTransition type="asset" items={assets} />;
  }

  if (property === "asset_type") {
    return <AssetsBatchEditAssetType assets={assets} />;
  }

  if (property === "condition_rating") {
    return <AssetsBatchEditConditionRating assets={assets} />;
  }

  if (property === "replacement_cost") {
    return <AssetsBatchEditReplacementCost assets={assets} />;
  }

  if (property === "location") {
    return <AssetsBatchEditLocation assets={assets} />;
  }

  // default footer, with "cancel" button
  return <SidePanelFormFooter hideSubmit />;
};
